
var VRC = VRC || {};

/**
 * Table for VoaygeEvents.
 * Initilizes and
 * @type {{init, deactivate, update}}
 */

VRC.VoyageLogTableView = (function(){
    var _hasFuel = false;
    var _hasLng = false;
    var eventLogTableId = "#event_log_table";
    var $eventLogTable;

    var init = function(){
      addHeaders();
      refresh();
    };

    var isDpModeEnabled = function () {
        return g_data_list.enableVoyageDpMode === 'yes'
    };

    var refresh = function(){
        VRC.TableSorterParsers.removeInputFieldListerens(eventLogTableId);
        VRC.TableSorterParsers.addInputFieldListeners(eventLogTableId);

        var inside500mZonePosition = VRC.MasterDataService.getInside500mZonePosition();

        var headers;

        switch (inside500mZonePosition) {
            case 'beforeEventTypes':
                headers = {
                    0: { sorter: false },
                    1: { sorter: "select" },
                    2: { sorter: "select" },
                    3: { sorter: "select"},
                    4: { sorter: false },
                    5: { sorter: "inputs-date" },
                    6: { sorter: "inputs" },
                    7: { sorter: "inputs" },
                    8: { sorter: false },
                    9: {  sorter: "inputs" },
                    10: {  sorter: false  }
                };
                break;
            case 'afterEventTypes':
                    headers = {
                    0: { sorter: "select" },
                    1: { sorter: "select" },
                    2: { sorter: false },
                    3: { sorter: "select"},
                    4: { sorter: false },
                    5: { sorter: "inputs-date" },
                    6: { sorter: "inputs" },
                    7: { sorter: "inputs" },
                    8: { sorter: false },
                    9: {  sorter: "inputs" },
                    10: {  sorter: false  }
                };
                break;
            default:
                headers = {
                    0: { sorter: "select" },
                    1: { sorter: "select" },
                    2: { sorter: "select"},
                    3: { sorter: false },
                    4: { sorter: "inputs-date" },
                    5: { sorter: "inputs" },
                    6: { sorter: "inputs" },
                    7: { sorter: false },
                    8: {  sorter: "inputs"  },
                    9: {  sorter: false  }
                };
        }

        $eventLogTable = $(eventLogTableId);
        $eventLogTable.tablesorter({
            headers: headers,
            headerTemplate: '{content} {icon}',
            dateformat : g_timeStampFormat
        });

    };

    var addHeaders = function(){
        setFuelTanks();
        var headerData = {hasFuel : _hasFuel, hasLng : _hasLng, inside500mZonePosition : VRC.MasterDataService.getInside500mZonePosition(), isDpModeEnabled: isDpModeEnabled()};
        var $eventLogTable = $(eventLogTableId);
        $eventLogTable.find('thead').remove();
        $eventLogTable.prepend(WELL.Handlebars.VRC.event_log_headers(headerData));
    };

    var setFuelTanks = function(){
        var fuelTanks = VRC.BulkTankManager.getFuelTanks();
        for(var ii = 0; ii < fuelTanks.length; ii++){
            if(fuelTanks[ii].isFuel()){
                _hasFuel = true;
            }
            else if(fuelTanks[ii].isLng()){
                _hasLng = true;
            }
        }
    };

    var deactivate = function(){

        VRC.TableSorterParsers.removeInputFieldListerens(eventLogTableId);

    };

    var update = function(){
        $eventLogTable.trigger("update");
        $eventLogTable.trigger("appendCache");
    };


    return {
      init : init,
      refresh : refresh,
      deactivate : deactivate,
      update : update
    }
})();
